import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text, TextField, Select, Stack } from '@eds-web/react';
import { FormikProps } from 'formik';
import { TaxProfile } from '../../types/payout.types';

interface AddressSectionProps {
    formik: FormikProps<any>;
    taxProfile: TaxProfile;
    isDisabled: boolean;
    stateList: any[] | null;
    defaultState: any;
    handleChangeFormValues: (_: string, arg?: any) => void;
}

export const AddressSection: React.FC<AddressSectionProps> = ({
    formik,
    taxProfile,
    isDisabled,
    stateList,
    defaultState,
    handleChangeFormValues
}) => {
    const { t } = useTranslation();
    const useSelect = ['US', 'CA', 'AU'].indexOf(taxProfile.addressCountryCode) > -1;

    return (
        <Stack gap={24}>
            <Text variant="headingSM">{t('epic.esport.profile.title.permanent')}</Text>
            <div className="form-column">
                <TextField
                    label={t('epic.esport.label.profile.address1')}
                    name="addressLine1"
                    value={formik.values.addressLine1}
                    onChange={handleChangeFormValues}
                    placeholder={t('epic.esport.label.profile.address1')}
                    disabled={isDisabled}
                    error={formik.touched.addressLine1 && (formik.errors.addressLine1 as string)}
                    required
                />
                <TextField
                    label={t('epic.esport.label.profile.address2')}
                    name="addressLine2"
                    value={formik.values.addressLine2}
                    onChange={handleChangeFormValues}
                    placeholder={t('epic.esport.label.profile.address2')}
                    disabled={isDisabled}
                    error={formik.touched.addressLine2 && (formik.errors.addressLine2 as string)}
                />
            </div>
            <div className="form-column">
                <TextField
                    label={t('epic.esport.label.payoutInfo.city')}
                    name="addressCity"
                    value={formik.values.addressCity}
                    onChange={handleChangeFormValues}
                    placeholder={t('epic.esport.label.payoutInfo.city')}
                    disabled={isDisabled}
                    error={formik.touched.addressCity && (formik.errors.addressCity as string)}
                    required
                />
                {useSelect ? (
                    <Select
                        label={t('epic.esport.label.profile.region')}
                        options={stateList as any}
                        defaultValue={defaultState}
                        disabled={isDisabled}
                        placeholder={t('epic.esport.label.profile.region')}
                        onChange={(selected: any) => {
                            formik.setFieldValue('addressState', selected?.value);
                            formik.setFieldTouched('addressState', true, false);
                        }}
                    />
                ) : (
                    <TextField
                        label={t('epic.esport.label.profile.region')}
                        name="addressState"
                        value={formik.values.addressState}
                        onChange={handleChangeFormValues}
                        placeholder={t('epic.esport.label.profile.region')}
                        disabled={isDisabled}
                        error={
                            formik.touched.addressState && (formik.errors.addressState as string)
                        }
                    />
                )}
            </div>
            <div className="form-column">
                <TextField
                    label={t('epic.esport.label.payoutInfo.country')}
                    value={taxProfile?.addressCountryCode}
                    placeholder={t('epic.esport.label.payoutInfo.country')}
                    disabled
                />
                <TextField
                    label={t('epic.esport.label.profile.postalCode')}
                    name="addressPostCode"
                    value={formik.values.addressPostCode}
                    onChange={handleChangeFormValues}
                    placeholder={t('epic.esport.label.profile.postalCode')}
                    disabled={isDisabled}
                    error={
                        formik.touched.addressPostCode && (formik.errors.addressPostCode as string)
                    }
                />
            </div>
        </Stack>
    );
};
